import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from '../types';

const largeIcon = (
  <path d="m6.4 9.2h0.2c0.77 0 1.4 0.63 1.4 1.4v7c0 0.77-0.63 1.4-1.4 1.4h-0.2c-0.77 0-1.4-0.63-1.4-1.4v-7c0-0.77 0.63-1.4 1.4-1.4zm5.6-4.2c0.77 0 1.4 0.63 1.4 1.4v11.2c0 0.77-0.63 1.4-1.4 1.4s-1.4-0.63-1.4-1.4v-11.2c0-0.77 0.63-1.4 1.4-1.4zm5.6 8c0.77 0 1.4 0.63 1.4 1.4v3.2c0 0.77-0.63 1.4-1.4 1.4s-1.4-0.63-1.4-1.4v-3.2c0-0.77 0.63-1.4 1.4-1.4z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7.50006 3.43506C7.8121 3.43506 8.06506 3.68802 8.06506 4.00006V12.0001C8.06506 12.3121 7.8121 12.5651 7.50006 12.5651C7.18802 12.5651 6.93506 12.3121 6.93506 12.0001V4.00006C6.93506 3.68802 7.18802 3.43506 7.50006 3.43506ZM4.50006 5.43506C4.8121 5.43506 5.06506 5.68802 5.06506 6.00006V12.0001C5.06506 12.3121 4.8121 12.5651 4.50006 12.5651C4.18802 12.5651 3.93506 12.3121 3.93506 12.0001V6.00006C3.93506 5.68802 4.18802 5.43506 4.50006 5.43506ZM11.0651 8.00006C11.0651 7.68802 10.8121 7.43506 10.5001 7.43506C10.188 7.43506 9.93506 7.68802 9.93506 8.00006V12.0001C9.93506 12.3121 10.188 12.5651 10.5001 12.5651C10.8121 12.5651 11.0651 12.3121 11.0651 12.0001V8.00006Z"
  />
);

export const BarChartIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="BarChart" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
